export function createAppCheck(source, e, component) {
  e.preventDefault();

  if (!window.devsite.user) {
    component.setState({ showLoginModal: true });
    return;
  } else if (!window.devsite.user.is_verified) {
    window.alert('Please verify your email address before creating an app');
    return;
  }

  return window.location.assign('https://' + window.location.host + '/apps/new?source=' + source);
}

export function ucwords(string) {
  return string.toLowerCase().replace(/\b[a-z]/g, function (letter) {
    return letter.toUpperCase();
  });
}
